import orionLogoLight from './orion-logo-light.png';
import {ORION_PROMO, getOrionLink} from './config';
import './styles.scss';

const OrionBanner = () => (
  <div className="orion-banner-wrap">
    <div className="orion-banner">
      <img src={orionLogoLight} alt="OR:ON" className="orion-banner__logo" />
      <span className="orion-banner__text">{ORION_PROMO.headline}</span>
      <a href={getOrionLink('hellobar')} className="orion-banner__btn">
        {ORION_PROMO.cta}
      </a>
    </div>
  </div>
);

export default OrionBanner;
